import GroupNotesDetailsWrapper from "@/pages/groups/notes/GroupNoteDetailsWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/groepen/$groupId/notities/$noteThreadId/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId, noteThreadId } = useParams({
    from: "/beheer/groepen/$groupId/notities/$noteThreadId/",
  })

  return (
    <GroupNotesDetailsWrapper
      groupId={Number(groupId)}
      noteThreadId={Number(noteThreadId)}
    />
  )
}
